import React, { Component, Fragment } from 'react';
import './Video.module.scss';

import generateClipPath from 'utilities/generateClipPath'

class Video extends Component {

    constructor(props) {
        super(props);
        
    }

    render() {
        return (
            <Fragment>
                {this.props.item.video_type &&
                <div style={this.props.item.video_type == 'vimeo' ? {paddingBottom: '56%'} : null} styleName='aspect-ratio'>
                    {this.props.item.video_type == 'youtube' &&
                        <iframe style={{width:'100%', height:'100%'}} src={`https://www.youtube.com/embed/${this.props.item.video_id}`} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    }
                    {this.props.item.video_type == 'vimeo' &&
                        <iframe src={`https://player.vimeo.com/video/${this.props.item.video_id}`} style={{width:'100%', height:'100%'}} frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                    }
                </div>
                }
            </Fragment>
        );
    }
}

export default Video;
